import { GiveawayPrizeItem } from '@/views/PreSales/PreSalesGiveawayView/config'

export const calculatePrizeValue = (
  prizes: GiveawayPrizeItem[] | undefined,
  shouldRoundToThousands = false,
): string => {
  if (!prizes || prizes.length === 0) return '$0'

  const total = prizes.reduce((sum, prize) => {
    if (!prize.value) return sum
    const numericValue = parseFloat(prize.value.replace(/[^\d.]/g, ''))
    return sum + (isNaN(numericValue) ? 0 : numericValue)
  }, 0)

  const finalTotal = shouldRoundToThousands ? Math.floor(total / 1000) * 1000 : total

  const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  return priceFormatter.format(finalTotal)
}
